import React, { useState } from 'react';
import { modelClass, Asset } from '/imports/api/assets';
import { listBots, Bot } from '/imports/api/bots';
import { listCards, Card } from '/imports/api/cards';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { RichSelect } from '/imports/ui/RichSelect';

// The /assets list, with two rich-select filters:
//   - Bot: everything a single bot holds.
//   - Item: every bot holding one card / avatar / event ticket.
// Both drive ModelListPage's `query`, so they compose (a bot AND an item
// narrows to that bot's holding of that item).
export const AssetsPage = () => {
  const [botName, setBotName] = useState('');
  const [cardId, setCardId] = useState('');

  return (
    <ModelListPage<Asset>
      modelClass={modelClass as any}
      permission={(user) => !!user?.isSuperUser}
      query={() => ({
        ...(botName ? { bot: botName } : {}),
        ...(cardId ? { cardId: Number(cardId) } : {}),
      })}
      extraFilters={
        <>
          <RichSelect<Bot>
            placeholder="Filter by bot…"
            listMethod={listBots}
            value={botName || undefined}
            clearable
            mapToValue={(bot) => ({ value: bot.username, label: bot.username, data: bot })}
            onChange={(option) => setBotName(option.value)}
            onClear={() => setBotName('')}
          />
          <RichSelect<Card>
            placeholder="Filter by card / avatar / ticket…"
            listMethod={listCards}
            value={cardId || undefined}
            clearable
            mapToValue={(card) => ({
              value: String(card._id),
              label: card.setName ? `${card.name} (${card.setName})` : card.name,
              data: card,
            })}
            onChange={(option) => setCardId(option.value)}
            onClear={() => setCardId('')}
          />
        </>
      }
      columns={[
        { field: 'bot', label: 'Bot' },
        { field: 'cardId', label: 'Card ID', className: 'mono' },
        { field: 'card', label: 'Card' },
        {
          field: 'set', label: 'Set', className: 'mono',
          render: (doc, refs) => (refs?.cardId?.[doc.cardId] as Card | undefined)?.setName ?? '',
        },
        { field: 'qty', label: 'Qty', className: 'mono' },
        { field: 'tradeable', label: 'Tradeable' },
      ]}
    />
  );
};
